export const atLeastOneGreaterThanZero = (values: number[]) => values.some(value => value > 0);
